// FacultyProfile.js
import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import './facultyprofile.css';

export default function FacultyProfile() {
  const [selectedImage, setSelectedImage] = useState(null);
  const [facultyData, setFacultyData] = useState({
    username: '',
    name: '',
    designation: '',
    qualification: '',
    objectives: '',
    email: '',
    fimages: '',
    phoneNumber: '',
    department: '',
    currentPortfolio: '',
    diplomas: '',
    professionalBackground: '',
    areasOfExpertise: '',
    currentResearchInterests: '',
    professionalSkills: '',
    researchImpact: '',
    fundedProjects: '',
    patents: '',
    coursesCurrentlyTeaching: '',
    coursesTaughtPreviously: '',
    supervisedCompletedTheses: '',
    currentlySupervisingTheses: '',
    proposedResearchTopics: '',
    professionalMemberships: '',
    awardsDistinctions: '',
    nominations: '',
    professionalCertificates: '',
    volunteerWork: '',
    otherDistinctions: '',
    personalInterests: '',
    officeHours: '',
    GoogleScholar: '',
    ORCID: '',
    LinkedIn: '',
    Scopus: '',
    personalWebsite: '',
    publications: []
  });

  const [tempValues, setTempValues] = useState({ ...facultyData });
  const [showPublicationModal, setShowPublicationModal] = useState(false);
  const [showModifyModal, setShowModifyModal] = useState(false);
  const [newPublication, setNewPublication] = useState({ type: '', details: '' });
  const [modifyingPublication, setModifyingPublication] = useState({ id: null, details: '' });

  const { id } = useParams();
  const navigate = useNavigate();
  const authToken = localStorage.getItem('authToken');

  // Fetch & auth on mount
  useEffect(() => {
    if (!authToken) {
      navigate('/login');
      return;
    }
    let loggedInUserId;
    try {
      const decoded = jwtDecode(authToken);
      loggedInUserId = decoded.id;
    } catch (err) {
      console.error('Invalid token:', err);
      localStorage.removeItem('authToken');
      navigate('/login');
      return;
    }
    if (parseInt(id, 10) !== loggedInUserId) {
      alert('Access denied!!!');
      navigate('/');
      return;
    }
    (async () => {
      try {
        const res = await fetch(`http://121.52.154.120:3001/faculty/${id}`, {
          headers: { Authorization: `Bearer ${authToken}` }
        });
        if (!res.ok) throw new Error(`Status ${res.status}`);
        const data = await res.json();
        setFacultyData(data);
        setTempValues({ ...data });
      } catch (err) {
        console.error('Error fetching faculty data:', err);
        navigate('/login');
      }
    })();
  }, [id, authToken, navigate]);

  // single‐field updater
  const handleUpdate = async (field) => {
    try {
      const updated = { ...facultyData, [field]: tempValues[field] };
      const res = await fetch('http://121.52.154.120:3001/updateFaculty', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${authToken}`
        },
        body: JSON.stringify(updated)
      });
      if (!res.ok) throw new Error(await res.text());
      setFacultyData(updated);
      alert(`${field} updated successfully`);
    } catch (err) {
      console.error('Update error:', err);
      alert('Update failed: ' + err.message);
    }
  };

  // image upload
  const uploadImage = async () => {
    if (!selectedImage) {
      alert('Please select an image first.');
      return;
    }
    const formData = new FormData();
    formData.append('image', selectedImage);
    formData.append('facultyId', facultyData.id);
    try {
      const res = await fetch('http://121.52.154.120:3001/api/faculty/uploadImage', {
        method: 'POST',
        headers: { Authorization: `Bearer ${authToken}` },
        body: formData,
      });
      if (!res.ok) throw new Error('Failed to upload image.');
      const result = await res.json();
      setFacultyData(f => ({ ...f, fimages: result.imageUrl }));
      setTempValues(tv => ({ ...tv, fimages: result.imageUrl }));
      alert(`Image uploaded: ${result.imageUrl}`);
    } catch (err) {
      console.error('Image upload error:', err);
      alert('Image upload failed.');
    }
  };

  // publications CRUD
  const addPublication = async () => {
    try {
      const res = await fetch('http://121.52.154.120:3001/addPublication', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${authToken}`
        },
        body: JSON.stringify({
          facultyId: id,
          publicationType: newPublication.type,
          details: newPublication.details
        })
      });
      if (!res.ok) throw new Error(await res.text());
      const added = await res.json();
      setFacultyData(f => ({ ...f, publications: [...f.publications, added] }));
      setNewPublication({ type: '', details: '' });
      setShowPublicationModal(false);
    } catch (err) {
      console.error('Error adding publication:', err);
      alert('Error adding publication: ' + err.message);
    }
  };

  const deletePublication = async (pubId) => {
    try {
      const res = await fetch(`http://121.52.154.120:3001/deletePublication/${pubId}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${authToken}`
        }
      });
      if (!res.ok) throw new Error(await res.text());
      setFacultyData(f => ({
        ...f,
        publications: f.publications.filter(p => p.id !== pubId)
      }));
      alert('Publication deleted.');
    } catch (err) {
      console.error('Error deleting publication:', err);
      alert('Error deleting publication: ' + err.message);
    }
  };

  const openModifyModal = (pub) => {
    setModifyingPublication({ id: pub.id, details: pub.details || '' });
    setShowModifyModal(true);
  };

  const modifyPublication = async () => {
    try {
      const res = await fetch(
        `http://121.52.154.120:3001/modifyPublication/${modifyingPublication.id}`,
        {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${authToken}`
          },
          body: JSON.stringify({ details: modifyingPublication.details })
        }
      );
      if (!res.ok) throw new Error(await res.text());
      const updatedPub = await res.json();
      setFacultyData(f => ({
        ...f,
        publications: f.publications.map(p =>
          p.id === updatedPub.id ? updatedPub : p
        )
      }));
      setShowModifyModal(false);
    } catch (err) {
      console.error('Error modifying publication:', err);
      alert('Error modifying publication: ' + err.message);
    }
  };

  // group them by type for display
  const groupedPublications = facultyData.publications.reduce((acc, pub) => {
    const type = pub.publication_type || 'Other';
    acc[type] = acc[type] || [];
    acc[type].push(pub);
    return acc;
  }, {});

  // dynamic field renderer
  const renderField = (label, field, type = 'text') => (
    <div className="form_rows" key={field}>
      <label>{label}:</label>
      {type === 'textarea' ? (
        <textarea
          value={tempValues[field] || ''}
          onChange={e =>
            setTempValues(tv => ({ ...tv, [field]: e.target.value }))
          }
        />
      ) : (
        <input
          type={type}
          value={tempValues[field] || ''}
          onChange={e =>
            setTempValues(tv => ({ ...tv, [field]: e.target.value }))
          }
        />
      )}
      <button onClick={() => handleUpdate(field)}>Update {label}</button>
    </div>
  );

  return (
    <div className='faculty-Profile'>
      <header className='height-100'>
        <h1 className='text-center fw-semibold'>Faculty Profile</h1>
        <h2 className='text-center w-100 mb-5'>
          Welcome, {facultyData.username || '…'}!
        </h2>
        <h3 className='text-center w-100 mb-2'>Please enter your details.</h3>
      </header>

      <div className='faculty-profile_container my-5'>
        {/* all the editable fields */}
        <div className="form">
          {renderField('Name', 'name')}
          <div className="form_rows">
            <label>Profile Image:</label>
            <input
              type="file"
              accept="image/*"
              onChange={e => setSelectedImage(e.target.files[0])}
            />
            <button onClick={uploadImage}>Upload Image</button>
          </div>
          {renderField('Designation', 'designation')}
          {renderField('Qualification', 'qualification', 'textarea')}
          {renderField('Objectives / Biography', 'objectives', 'textarea')}
          {renderField('Email', 'email', 'email')}
          {renderField('Phone Number', 'phoneNumber')}
          {renderField('Department', 'department')}
          {renderField('Current Portfolio', 'currentPortfolio', 'textarea')}
          {renderField('Diplomas', 'diplomas', 'textarea')}
          {renderField('Professional Background', 'professionalBackground', 'textarea')}
          {renderField('Areas Of Expertise', 'areasOfExpertise', 'textarea')}
          {renderField('Current Research Interests', 'currentResearchInterests', 'textarea')}
          {renderField('Professional Skills', 'professionalSkills', 'textarea')}
          {renderField('Research Impact', 'researchImpact', 'textarea')}
          {renderField('Funded Projects', 'fundedProjects', 'textarea')}
          {renderField('Patents', 'patents', 'textarea')}
          {renderField('Courses Currently Teaching', 'coursesCurrentlyTeaching', 'textarea')}
          {renderField('Courses Taught Previously', 'coursesTaughtPreviously', 'textarea')}
          {renderField('Supervised Completed Theses', 'supervisedCompletedTheses', 'textarea')}
          {renderField('Currently Supervising Theses', 'currentlySupervisingTheses', 'textarea')}
          {renderField('Proposed Research Topics', 'proposedResearchTopics', 'textarea')}
          {renderField('Professional Memberships', 'professionalMemberships', 'textarea')}
          {renderField('Awards & Distinctions', 'awardsDistinctions', 'textarea')}
          {renderField('Nominations', 'nominations', 'textarea')}
          {renderField('Professional Certificates', 'professionalCertificates', 'textarea')}
          {renderField('Volunteer Work', 'volunteerWork', 'textarea')}
          {renderField('Other Distinctions', 'otherDistinctions', 'textarea')}
          {renderField('Personal Interests', 'personalInterests', 'textarea')}
          {renderField('Office Hours', 'officeHours', 'textarea')}
          {renderField('Google Scholar', 'GoogleScholar')}
          {renderField('ORCID', 'ORCID')}
          {renderField('LinkedIn', 'LinkedIn')}
          {renderField('Scopus', 'Scopus')}
          {renderField('Personal Website', 'personalWebsite')}
        </div>

        {/* Publications */}
        <div>
          <h2>Research Publications</h2>
          <div className="publication-list">
            {Object.keys(groupedPublications).map(type => (
              <div key={type}>
                <h3>{type.charAt(0).toUpperCase() + type.slice(1)}</h3>
                {groupedPublications[type].map((pub, i) => (
                  <div key={i} className="publication-item">
                    <p className="publication-details">{pub.details}</p>
                    <div className="publication-controls">
                      <button className="btn update-btn" onClick={() => openModifyModal(pub)}>
                        Modify
                      </button>
                      <button className="btn delete-btn" onClick={() => deletePublication(pub.id)}>
                        Delete
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            ))}
            <button className="btn add-btn" onClick={() => setShowPublicationModal(true)}>+</button>
          </div>
        </div>

        {/* Add Publication Modal */}
        {showPublicationModal && (
          <div className="modal" style={{ zIndex: 9999 }}>
            <h3>Add Publication</h3>
            <div className="form_rows">
              <label>Publication Type:</label>
              <select
                value={newPublication.type}
                onChange={e => setNewPublication(n => ({ ...n, type: e.target.value }))}
              >
                <option value="" disabled>Select Type</option>
                <option value="journal Publications">Journal Publications</option>
                <option value="conference">Conferences</option>
                <option value="book">Books</option>
                <option value="Book Chapters">Book Chapters</option>
                <option value="articles">Articles</option>
              </select>
            </div>
            <div className="form_rows">
              <label>Details:</label>
              <textarea
                value={newPublication.details}
                onChange={e => setNewPublication(n => ({ ...n, details: e.target.value }))}
              />
            </div>
            <div className="form_rows">
              <button onClick={addPublication}
                      disabled={!newPublication.type || !newPublication.details}>
                Add
              </button>
              <button onClick={() => setShowPublicationModal(false)}>Cancel</button>
            </div>
          </div>
        )}

        {/* Modify Publication Modal */}
        {showModifyModal && (
          <div className="modal" style={{ zIndex: 9999 }}>
            <h3>Modify Publication</h3>
            <textarea
              value={modifyingPublication.details}
              onChange={e => setModifyingPublication(m => ({ ...m, details: e.target.value }))}
              style={{ width: '100%', minHeight: '100px' }}
            />
            <div className="form_rows">
              <button onClick={modifyPublication}>Modify</button>
              <button onClick={() => setShowModifyModal(false)}>Cancel</button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
